import React from "react";

import { Nullable } from "models/Nullable";
import { OfferRoom } from "models/OfferRoom";
import { PriceField } from "models/PriceField";

import { SummaryList, TTableRowData } from "./SummaryTable";

type Props = {
    offerRooms: OfferRoom[]
    discount?: Nullable<number>
    manualPrice: Nullable<number>
    hideUnitPrices: boolean
}

export function BasicSummaryTable({ offerRooms, discount, manualPrice, hideUnitPrices }: Props) {

    const priceFieldCounts: {
        [priceFieldId: string]: {
            priceField: PriceField
            count: number
        }
    } = {};

    offerRooms.forEach((offerRoom) => {
        Object.values(offerRoom.priceFields).forEach(({ count, priceField }) => {
            priceFieldCounts[priceField.id] = {
                priceField,
                count: (priceFieldCounts[priceField.id]?.count || 0) + count
            }
        })
    })

    const rows: TTableRowData[] = Object.values(priceFieldCounts).map(({ priceField, count }) => ({
        priceFieldId: priceField.id,
        priceFieldName: priceField.name?.text,
        priceFieldCount: count,
        priceFieldPrice: priceField.price,
    }));

    return (
        // Empty group name and id will be displayed as ungrouped
        <SummaryList 
        hideUnitPrices={hideUnitPrices} 
        itemsSubheader="Produkter" 
        discount={discount}
        manualPrice={manualPrice}
         groups={[{ groupId: '', roomId: '', groupName: '', rows }]} 
         />
    )
}
